import { IDocLinksNode } from '@infotech-soe/merps/types/docLinks';
import { CategoryName, DbId } from '@infotech-soe/metaschema';
import { createSlice } from '@reduxjs/toolkit';

import { failureAction, pendingAction, successAction } from './actionHandler';

export interface IGraphData extends IDocLinksNode {
  label: string;
}

interface GraphState {
  show: boolean;
  nodes: IGraphData[];
  docId: DbId;
}

const initialState: GraphState = {
  show: false,
  nodes: [],
  docId: 0,
};

const graphSlice = createSlice({
  name: 'graph',
  initialState,
  reducers: {
    open: pendingAction<
      GraphState,
      { categoryName: CategoryName; docId: DbId }
    >((state, { payload }) => {
      state.docId = payload.docId;
    }),
    openSuccess: successAction<GraphState, IGraphData[]>(
      (state, { payload }) => {
        state.nodes = payload;
        state.show = true;
      }
    ),
    openFailure: failureAction(),
    close() {
      return initialState;
    },
  },
});

export const graphReducer = graphSlice.reducer;

export default graphSlice.actions;
